// extracted by mini-css-extract-plugin
export default {"mainWrapper":"domestic_mainWrapper__ZJZHI","actionButtons":"domestic_actionButtons__m89jv","rowWrapper":"domestic_rowWrapper__jrX2q"};